export default "__VITE_ASSET__BqI8GQ_T__"